export const adtypeFilterItems = [
  "virtual_tour_url",
  "icerik_turu",
  "price_trend",
  "price_index",
  "virtual_decoration",
  "campaigns",
];
